const rulesOdds = {
  methods: {
    editDataSports: function(categories) {
      for (const categorie of categories) {
        for (const tournament of categorie.tournaments) {
          for (const event of tournament.events) {
            for (const odd of event.odds) {
              this.checkRules(odd);
            }
          }
        }
      }
    },

    RoundHalfDown: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },

    checkRules: function(odd) {
      const logged = this.$store.state.logged.status;
      const odd_price = Number(odd.odd_price);
      this.$set(odd, "odd_price_real", odd_price);

      const storeOutcome = this.$store.getters.getResults.find(
        ({ id_outcome }) => id_outcome == odd.id_outcome
      );

      if (storeOutcome.active != "1") {
        odd.blocked = true;
        odd.active = false;
      }

      // Status = 2 Bloqueia:
      if (odd.active != "1") {
        odd.blocked = true;
        odd.active = false;
      }

      let margin;
      if (logged) {
        const { margin_odds } = this.$store.state.logged.data;
        margin = Number(margin_odds) + Number(odd.margin);
      } else {
        margin = Number(odd.margin);
      }

      let odd_price_discount = odd_price - odd_price * margin;

      let marginLimit =
        odd_price_discount >= odd.odd_limit
          ? odd.odd_limit
          : odd_price_discount;

      this.$set(odd, "odd_price", this.RoundHalfDown(Number(marginLimit)));
    },
  },
};

export default rulesOdds;
